import { NewsDetailInsert, NewsDetailDelete, NewsDetailUpdate, NewsDetailGetById, NewsDetailGetList, NewsDetailGetPageList } from "@/api/newsdetail/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    NewsDetailInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            NewsDetailInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    NewsDetailUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            NewsDetailUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    NewsDetailGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            NewsDetailGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    NewsDetailGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            NewsDetailGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    NewsDetailGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            NewsDetailGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}